import React, { Component } from 'react';
import { connect } from 'react-redux';

import { categoryfilter } from '../../actions';

class CategorySelect extends Component {
	constructor() {
		super();
		this.exclude = [ 'uncategorized', 'opinions', 'protocols' ];
	}

	getTopLevelCategories() {
		return this.props.categories.filter( category => 0 === category.parent );
	}

	handleChange( event ) {
		this.props.categoryfilter( event.target.value );
	}

	isActive( slug, selectedSlug ) {
		return (slug === selectedSlug
		       ) ? 'active' : '';
	}

	renderCategoryButtons() {
		const topLevelCategories = this.getTopLevelCategories();

		return topLevelCategories.map( ( category, i ) => {
			if ( !this.exclude.includes( category.slug ) ) {
				return (<option key={ i }
				                value={ category.slug }
				                dangerouslySetInnerHTML={ { __html: category.name } } />
				);
			}
		} );
	}

	render() {
		if ( 'posts' === this.props.postType ) {
			return (
				<div className="form-group-keyword form-group col-sm-12 col-md-5">
					<h2 className="filter-title" htmlFor="category-select-filter">Filter by Category</h2>
					<select className="form-control filter-category" id="category-select-filter" onChange={ this.handleChange.bind( this ) } value={ this.props.selectedCategory } aria-label="Category Filter">
						<option value="">All Categories</option>
						{ this.renderCategoryButtons() }
					</select>
				</div>
			);
		} else {
			return <span />;
		}
	}
}

function mapStateToProps( { categories, selectedCategory, postType } ) {
	return { categories, selectedCategory, postType };
}

export default connect( mapStateToProps, { categoryfilter } )( CategorySelect );